import axios from 'axios';
import { api } from '@/api';

const types = {
    SET_LANGUAGES: 'SET_LANGUAGES',
    FETCH_FAILURE: 'FETCH_FAILURE',
}

export const state = {
    languages: [],
}

export const mutations = {
    [types.SET_LANGUAGES](state: any, data: any ) {
        state.languages = data;
    }
}

export const actions = {

    async fetchLanguages({ commit }: any) {
        try {
            if (state.languages.length !== 0) {
                return;
            }
            const { data } = await axios.get(api.path('v1.languages'), { params: {  paginate: 'no' } });
            commit(types.SET_LANGUAGES, data.data);
        } catch (e) {
            commit(types.FETCH_FAILURE);
        }
    },

    async refreshLanguages({ commit }: any ) {
        try {
            const { data } = await axios.get(api.path('v1.languages'), { params: {  paginate: 'no' } });
            commit(types.SET_LANGUAGES, data.data);
        } catch (e) {
            commit(types.FETCH_FAILURE)
        }
    },

    setLanguages({ commit }: any, payload: any) {
        commit(types.SET_LANGUAGES, payload)
    },

}

export const getters = {
    languages: ( state: any ) => state.languages,
}